var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search-view"}},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 "},[_c('vue-autosuggest',{attrs:{"suggestions":_vm.filteredOptions,"input-props":{
            id: 'autosuggest__input',
            placeholder: 'Search...',
          }},on:{"input":_vm.onInputChange,"selected":_vm.onSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var suggestion = ref.suggestion;
return [_c('span',{staticClass:"my-suggestion-item"},[_vm._v(_vm._s(suggestion.item))])]}}])})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }